import { render, staticRenderFns } from "./InstructorMobile.vue?vue&type=template&id=746f99ea&scoped=true"
import script from "./InstructorMobile.vue?vue&type=script&lang=js"
export * from "./InstructorMobile.vue?vue&type=script&lang=js"
import style0 from "./InstructorMobile.vue?vue&type=style&index=0&id=746f99ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746f99ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
